import { 
  FaUsers, 
  FaRocket, 
  FaGlobe, 
  FaTrophy, 
  FaHeart, 
  FaStar,
  FaHeadset 
} from "react-icons/fa";

// Utility functions
export const getIconForStat = (title, id) => {
  const lowerTitle = title.toLowerCase();
  
  if (lowerTitle.includes('client') || lowerTitle.includes('customer')) {
    return FaUsers;
  } else if (lowerTitle.includes('project') || lowerTitle.includes('delivered') || lowerTitle.includes('completed')) {
    return FaRocket;
  } else if (lowerTitle.includes('country') || lowerTitle.includes('countries') || lowerTitle.includes('global') || lowerTitle.includes('worldwide')) {
    return FaGlobe;
  } else if (lowerTitle.includes('support') || lowerTitle.includes('24/7') || lowerTitle.includes('help')) {
    return FaHeadset;
  } else if (lowerTitle.includes('award') || lowerTitle.includes('trophy') || lowerTitle.includes('winner')) {
    return FaTrophy;
  } else if (lowerTitle.includes('satisfaction') || lowerTitle.includes('rating') || lowerTitle.includes('star')) {
    return FaStar;
  } else if (lowerTitle.includes('love') || lowerTitle.includes('favorite')) {
    return FaHeart;
  } else {
    const icons = [FaUsers, FaRocket, FaGlobe, FaHeadset, FaTrophy, FaStar, FaHeart];
    const index = parseInt(id) % icons.length;
    return icons[index] || FaUsers;
  }
};

export const isSpecialDisplayCard = (title) => {
  const lowerTitle = title.toLowerCase();
  return lowerTitle.includes('24/7') || lowerTitle.includes('support');
};

export const getSpecialDisplayText = (title, count) => {
  const lowerTitle = title.toLowerCase();
  if (lowerTitle.includes('24/7')) {
    return '24/7';
  }
  return count;
};

export const shouldShowCountryAnimation = (title) => {
  const lowerTitle = title.toLowerCase();
  return lowerTitle.includes('country') || lowerTitle.includes('countries') || 
         lowerTitle.includes('global') || lowerTitle.includes('worldwide');
};

export const shouldShowClientAnimation = (title) => {
  const lowerTitle = title.toLowerCase();
  return lowerTitle.includes('client') || lowerTitle.includes('customer') || 
         lowerTitle.includes('happy client');
};

export const shouldShowLiveIndicator = (title) => {
  const lowerTitle = title.toLowerCase();
  return lowerTitle.includes('24/7') || lowerTitle.includes('support');
};

// Hardcoded stats data
export const hardcodedStatsData = [
  { 
    id: "5", 
    count: 300, 
    title: "Happy Clients", 
    icon: FaUsers, 
    isSpecialDisplay: false,
    showCountryAnimation: false,
    showClientAnimation: true,
    showLiveIndicator: false,
    isClickable: false
  },
  { 
    id: "6", 
    count: 450, 
    title: "Projects Delivered", 
    icon: FaRocket, 
    isSpecialDisplay: false,
    showCountryAnimation: false,
    showClientAnimation: false,
    showLiveIndicator: false,
    isClickable: false
  },
  { 
    id: "7", 
    count: 5, 
    title: "Countries Served", 
    icon: FaGlobe, 
    isSpecialDisplay: false,
    showCountryAnimation: true,
    showClientAnimation: false,
    showLiveIndicator: false,
    isClickable: false
  },
  { 
    id: "8", 
    count: 24, 
    title: "24/7 Support", 
    icon: FaHeadset, 
    isSpecialDisplay: true, 
    specialText: "24/7",
    showCountryAnimation: false,
    showClientAnimation: false,
    showLiveIndicator: true,
    isClickable: true
  },
];

// Load hardcoded data function
export const loadHardcodedStatsData = ({
  setStatsData,
  setLoading,
  setError
}) => {
  try {
    setLoading(true);
    setError(null);
    setStatsData(hardcodedStatsData);
  } catch (err) {
    console.error('Error loading hardcoded stats data:', err);
    setError(err.message);
  } finally {
    setLoading(false);
  }
};

// Commented out original API fetching function for future use
/*
export const fetchStatsData = async ({
  setStatsData,
  setLoading,
  setError,
  getIconForStat,
  shouldShowCountryAnimation,
  shouldShowClientAnimation,
  shouldShowLiveIndicator,
  isSpecialDisplayCard,
  getSpecialDisplayText
}) => {
  try {
    setLoading(true);
    setError(null);
    
    const response = await fetch('https://api.dremerz.net/api/DZ_8923_Idlbay_Stat_StatList');
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    const transformedData = data.map((item, index) => ({
      id: item.id || index.toString(),
      count: parseInt(item.count) || 0,
      title: item.title || 'Untitled',
      icon: getIconForStat(item.title || '', item.id || index.toString()),
      datetime: item.datetime,
      isSpecialDisplay: isSpecialDisplayCard(item.title || ''),
      specialText: getSpecialDisplayText(item.title || '', item.count || '0'),
      showCountryAnimation: shouldShowCountryAnimation(item.title || ''),
      showClientAnimation: shouldShowClientAnimation(item.title || ''),
      showLiveIndicator: shouldShowLiveIndicator(item.title || ''),
      isClickable: shouldShowLiveIndicator(item.title || '')
    }));
    
    setStatsData(transformedData);
  } catch (err) {
    console.error('Error fetching stats data:', err);
    setError(err.message);
    
    // Fallback data
    const fallbackData = [
      { 
        id: "1", 
        count: 300, 
        title: "Happy Clients", 
        icon: FaUsers, 
        isSpecialDisplay: false,
        showCountryAnimation: false,
        showClientAnimation: true,
        showLiveIndicator: false,
        isClickable: false
      },
      { 
        id: "2", 
        count: 450, 
        title: "Projects Delivered", 
        icon: FaRocket, 
        isSpecialDisplay: false,
        showCountryAnimation: false,
        showClientAnimation: false,
        showLiveIndicator: false,
        isClickable: false
      },
      { 
        id: "3", 
        count: 5, 
        title: "Countries Served", 
        icon: FaGlobe, 
        isSpecialDisplay: false,
        showCountryAnimation: true,
        showClientAnimation: false,
        showLiveIndicator: false,
        isClickable: false
      },
      { 
        id: "4", 
        count: 24, 
        title: "24/7 Support", 
        icon: FaHeadset, 
        isSpecialDisplay: true, 
        specialText: "24/7",
        showCountryAnimation: false,
        showClientAnimation: false,
        showLiveIndicator: true,
        isClickable: true
      },
    ];
    setStatsData(fallbackData);
  } finally {
    setLoading(false);
  }
};
*/